import { OrderStateModel } from '@shared/models/order.model';
import { Selector } from '@ngxs/store';
import { OrderState } from './order.state';
import { UpfrontPaymentMethod } from '@shared/enums/payment-type';
import { ContractTypeData } from '../../models/contract.model';

export class OrderSelectors {
  @Selector([OrderState])
  static getState(state: OrderStateModel): OrderStateModel {
    return state;
  }

  @Selector([OrderState])
  static salesPersonId(state: OrderStateModel): string {
    return state.salesPersonId;
  }

  @Selector([OrderState])
  static upfrontPaymentMethod(state: OrderStateModel): UpfrontPaymentMethod {
    return state.upfrontPaymentMethod;
  }

  @Selector([OrderState])
  static selectedContractSigningMethod(state: OrderStateModel): ContractTypeData {
    return state.contractSigningMethod;
  }

  @Selector([OrderState])
  static isServiceOrder(state: OrderStateModel): boolean {
    return state.isServiceOrder;
  }

  @Selector([OrderState])
  static currentOrderServiceId(state: OrderStateModel): string | null {
    return state.orderServiceId?.toString();
  }

  @Selector([OrderState])
  static placeOrderError(state: OrderStateModel): string {
    return state.placeOrderError;
  }

  @Selector([OrderState])
  static updatedProductIdentifierMsisdns(state: OrderStateModel): string[] {
    return state.updatedProductIdentifierMsisdns;
  }

  // Used in the case of a seller submitting an order and being automatic navigated to the order-details page
  // We then know that the order has just been placed because of the metadata stored in state
  @Selector([OrderState])
  static hasOrderJustBeenPlaced(state: OrderStateModel): boolean {
    return !!state.orderServiceId && !!state.orderCaptureId;
  }

  @Selector([OrderState])
  static bankIdMsisdn(state: OrderStateModel): string {
    return state.bankIdMsisdn;
  }

  @Selector([OrderState])
  static bankIdEmail(state: OrderStateModel): string {
    return state.bankIdEmail;
  }

  @Selector([OrderState])
  static isBankIdBypassed(state: OrderStateModel): boolean {
    return state.isBankIdBypassed;
  }

  @Selector([OrderState])
  static bankIdBypassNote(state: OrderStateModel): string {
    return state.bankIdBypassNote;
  }
}
